module.exports = __webpack_public_path__ + "img/English-Software-Information-step-3.497b3aee.png";